import type { TranslationKey } from '@athena/i18n'

/**
 * Why a practice cannot be started, in a student's words.
 *
 * The codes are the server's `startBlockedReason`, so this is a translation and
 * not a second opinion: if a rule changes, the server refuses differently and
 * this map is what needs a new line, rather than some condition elsewhere
 * quietly disagreeing. Shared by the home screen's card and the results
 * screen's "Try again", so the two say the same thing about the same refusal.
 */
const BLOCKED: Record<string, TranslationKey> = {
  PRACTICE_ARCHIVED: 'learn.card.blockedArchived',
  PRACTICE_CLOSED: 'learn.card.blockedClosed',
  MAX_ATTEMPTS_REACHED: 'learn.card.blockedMaxAttempts',
  PRACTICE_NOT_PUBLISHED: 'learn.card.blockedNotPublished',
}

export function startBlockedKey(reason: string | null | undefined): TranslationKey {
  return BLOCKED[reason ?? ''] ?? 'learn.card.notAvailable'
}
